module.exports = {
    SALE : ['Open','Paid','Partially Paid','Void'],
    EXPENSE : ['Open','Settled','Partially Settle','Void'],
};